/** GhostScreens player IndexedDB — durable media + offline state. */
export const PLAYER_DB_NAME = 'ghostscreen-player';
export const PLAYER_DB_VERSION = 1;
export const ASSETS_STORE = 'assets';
export const META_STORE = 'meta';
export const META_PLAYLIST_CACHE = 'playlist-cache';
export const META_SCHEDULE = 'schedule';
export function openPlayerDatabase(factory = indexedDB) {
    return new Promise((resolve, reject) => {
        const request = factory.open(PLAYER_DB_NAME, PLAYER_DB_VERSION);
        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains(ASSETS_STORE)) {
                db.createObjectStore(ASSETS_STORE, { keyPath: 'assetId' });
            }
            if (!db.objectStoreNames.contains(META_STORE)) {
                db.createObjectStore(META_STORE, { keyPath: 'key' });
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error ?? new Error('Failed to open player IndexedDB'));
    });
}
//# sourceMappingURL=database.js.map